import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { APInterceptor } from './shared/providers/APInterceptor';

@NgModule({
  declarations: [
    AppComponent,
  
    
   
    
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule.forRoot(),
    ToastrModule.forRoot({
      positionClass :'toast-top-right'
    }),
    LoggerModule.forRoot({
      serverLoggingUrl: environment.backend.baseURL + "/api/logs",
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: NgxLoggerLevel.TRACE,
      enableSourceMaps: true,
      disableConsoleLogging: true
    }),
    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: APInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
